import {
  getObject,
  getOptionalObject,
} from "@surya-digital/leo-ts-types";
import { SurveyLocalizedText, SurveyLocalizedTextDTO } from "../assets/surveyLocalizedText";

export interface SurveySettingDialogPropertiesDTO {
  titleText: SurveyLocalizedTextDTO;
  descriptionText: SurveyLocalizedTextDTO;
  primaryActionText: SurveyLocalizedTextDTO;
  secondaryActionText?: SurveyLocalizedTextDTO | null;
  buttonText?: SurveyLocalizedTextDTO | null;
}

export class SurveySettingDialogProperties {
  readonly isSurveySettingDialogPropertiesSurveySettingDialogProperties: boolean = true;

  readonly titleText: SurveyLocalizedText;
  readonly descriptionText: SurveyLocalizedText;
  readonly primaryActionText: SurveyLocalizedText;
  readonly secondaryActionText: SurveyLocalizedText | null;
  readonly buttonText: SurveyLocalizedText | null;


  constructor(
  titleText: SurveyLocalizedText, 
  descriptionText: SurveyLocalizedText, 
  primaryActionText: SurveyLocalizedText, 
  secondaryActionText: SurveyLocalizedText | null = null, 
  buttonText: SurveyLocalizedText | null = null
  ) {
    this.titleText = titleText;
    this.descriptionText = descriptionText;
    this.primaryActionText = primaryActionText;
    this.secondaryActionText = secondaryActionText;
    this.buttonText = buttonText;
  }

  static fromDTO(dto: SurveySettingDialogPropertiesDTO): SurveySettingDialogProperties {
    const titleText = SurveyLocalizedText.fromDTO(getObject(dto, "titleText", InvalidSurveySettingDialogPropertiesTitleTextError));
    const descriptionText = SurveyLocalizedText.fromDTO(getObject(dto, "descriptionText", InvalidSurveySettingDialogPropertiesDescriptionTextError));
    const primaryActionText = SurveyLocalizedText.fromDTO(getObject(dto, "primaryActionText", InvalidSurveySettingDialogPropertiesPrimaryActionTextError));
    let secondaryActionText = getOptionalObject(dto, "secondaryActionText");
    if(secondaryActionText !== undefined && secondaryActionText !== null) {
      secondaryActionText = SurveyLocalizedText.fromDTO(getObject(dto, "secondaryActionText", InvalidSurveySettingDialogPropertiesSecondaryActionTextError));
    }
    let buttonText = getOptionalObject(dto, "buttonText");
    if(buttonText !== undefined && buttonText !== null) {
      buttonText = SurveyLocalizedText.fromDTO(getObject(dto, "buttonText", InvalidSurveySettingDialogPropertiesButtonTextError));
    }
    return new SurveySettingDialogProperties(
      titleText,
      descriptionText,
      primaryActionText,
      secondaryActionText,
      buttonText
    );
  }

  toDTO(): SurveySettingDialogPropertiesDTO {
    const dto: SurveySettingDialogPropertiesDTO = {
        titleText: this.titleText.toDTO(),
        descriptionText: this.descriptionText.toDTO(),
        primaryActionText: this.primaryActionText.toDTO(),
    };
    if (this.secondaryActionText !== undefined && this.secondaryActionText !== null){
      dto.secondaryActionText = this.secondaryActionText.toDTO();
    }
    if (this.buttonText !== undefined && this.buttonText !== null){
      dto.buttonText = this.buttonText.toDTO();
    }
    return dto;
  }
  }

SurveySettingDialogProperties.prototype.toString = function toString(): string {
  return `SurveySettingDialogProperties(titleText='${this.titleText}',descriptionText='${this.descriptionText}',primaryActionText='${this.primaryActionText}',secondaryActionText='${this.secondaryActionText}',buttonText='${this.buttonText}')`;
};

export class InvalidSurveySettingDialogPropertiesError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveySettingDialogPropertiesError";
  }
}
export class InvalidSurveySettingDialogPropertiesTitleTextError extends InvalidSurveySettingDialogPropertiesError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveySettingDialogPropertiesTitleTextError";
  }
}

export class InvalidSurveySettingDialogPropertiesDescriptionTextError extends InvalidSurveySettingDialogPropertiesError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveySettingDialogPropertiesDescriptionTextError";
  }
}

export class InvalidSurveySettingDialogPropertiesPrimaryActionTextError extends InvalidSurveySettingDialogPropertiesError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveySettingDialogPropertiesPrimaryActionTextError";
  }
}

export class InvalidSurveySettingDialogPropertiesSecondaryActionTextError extends InvalidSurveySettingDialogPropertiesError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveySettingDialogPropertiesSecondaryActionTextError";
  }
}

export class InvalidSurveySettingDialogPropertiesButtonTextError extends InvalidSurveySettingDialogPropertiesError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveySettingDialogPropertiesButtonTextError";
  }
}
